import type {
  BaseConfigContact,
  ClientConfigContact,
} from '@bb/domain/dist/types/AppointmentConfig';
import axios from 'axios';
import { invalidateListingAppointmentConfigCache } from './getListingAppointmentConfig';

type UpdateClientContactParams = {
  listingId: string;
  contactId: string;
};

type UpdateClientContactBody = {
  contactBody: Omit<
    ClientConfigContact,
    | 'contactId'
    | 'ownerId'
    | 'canConfirmAppts'
    | 'canDenyAppts'
    | 'canSuggestTime'
    | 'importance'
    | 'notifications'
  >;
  contactConfig: Omit<
    BaseConfigContact,
    'type' | 'holdAppointments' | 'contactId'
  >;
  updateConfigOnly?: boolean;
};

const updateClientContact = async (
  params: UpdateClientContactParams,
  body: UpdateClientContactBody,
) => {
  const { data } = await axios.post(
    `/appointments/${params.listingId}/config/contacts/client/${params.contactId}`,
    body,
  );

  invalidateListingAppointmentConfigCache(params.listingId);

  return data;
};

export default updateClientContact;
